import { render } from "./EdicionRevendedoresView.vue?vue&type=template&id=377af770"
import script from "./EdicionRevendedoresView.vue?vue&type=script&lang=js"
export * from "./EdicionRevendedoresView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__